import React, { PureComponent } from 'react';
import FilmProjectInfo from './FilmProjectInfo';
import VideoPlayer from './../video-player/VideoPlayer';
import { widths, colors, fonts } from './../../styles/theme.json';

export default class FilmProjectTop extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: this.props.FilmData.auto_expand
    };
    this.toggleDropdown = this._toggleDropdown.bind(this);
  }

  _toggleDropdown() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  render() {
    return (
      <section id='film-project-top'>
        <VideoPlayer videoId={this.props.FilmData.vimeo_id} videoUrl={`https://vimeo.com/${this.props.FilmData.vimeo_id}`} videoPoster={this.props.FilmData.video_img.large} cta={'PLAY'}/>
        <div id={'film-detail-header'}>
          <div className={'headline'}>
            <h1 className={'medium-header hl-primary'} dangerouslySetInnerHTML={{ __html:this.props.FilmData.headline}}/>
            {(this.props.FilmData.description) &&
              <h2 className={'light-header hl-secondary'} dangerouslySetInnerHTML={{ __html: this.props.FilmData.description }} />
            }
          </div>
          {(this.props.FilmData.content) &&
            <div className={'expand'}>
              <button onClick={this.toggleDropdown} className={this.state.isOpen ? 'read-more small-header' : 'read-more closed small-header'}/>
            </div>
          }
        </div>
        {(this.props.FilmData.content) &&
          <div className={this.state.isOpen ? 'dropdown-content' : 'dropdown-content closed'}>
            <FilmProjectInfo ProjectInfo={this.props.FilmData}/>
          </div>
        }
      </section>
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/photo-film-project/FilmProjectTop.js